import { SilverwareCleanIcon } from './SilverwareCleanIcon';

/**
 * author: Simran
 * id 57F11CAE-4E4B-4406-A5A8-2F5A283ABF99
 * name silverware-clean
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/silverware-clean.svg
 * tags
 * - Food / Drink 
 */
export const UtensilsCleanIcon = SilverwareCleanIcon;
export default UtensilsCleanIcon